jQuery(document).ready(function () {
    //テーブルスクロール
    // $('table:not(.no_scroll)').each(function (index) {
    //     $(this).wrap('<div class="js-scrollable"></div>');
    // });
    // if ($('.js-scrollable').length) {
    //     new ScrollHint('.js-scrollable', {
    //         i18n: {
    //             scrollable: 'スクロールできます',
    //         },
    //     });
    // }

    $('.blocks-gallery-item').each(function (index) {
        var title = $(this).find('.blocks-gallery-item__caption').html();
        $(this).find('a').attr('title', title);
    });

    $('.blocks-gallery-item').magnificPopup({
        delegate: 'a',
        type: 'image',
        gallery: {
            //ギャラリー表示にする
            enabled: true,
        },
    });

    //アコーディオンパーツ
    $(".parts_accordion_title").on("click", function() {
        $(this).parent().toggleClass('active');
        $(this).next().slideToggle();
    });

});
